import { AccountingPeriod, Accumulated, TargetYear } from "@/types/enums";
import { cn } from "@/lib/utils";

const targetYearToString = (targetYear: TargetYear | null) => {
  switch (targetYear) {
    case TargetYear.CURRENT:
      return "당기";
    case TargetYear.PRIOR:
      return "전기";
    default:
      return "구분없음";
  }
};

const accountingPeriodToString = (
  accountingPeriod: AccountingPeriod | null,
) => {
  switch (accountingPeriod) {
    case AccountingPeriod.BEGIN:
      return "기초";
    case AccountingPeriod.END:
      return "기말";
    default:
      return "구분없음";
  }
};

const accumulationToString = (accumulation: Accumulated | null) => {
  switch (accumulation) {
    case Accumulated.QUARTER_ACC:
      return "3개월";
    case Accumulated.ACC:
      return "누적";
    default:
      return "구분없음";
  }
};

export const CellPeriodChips = ({
  className,
  targetYear,
  accountingPeriod,
  accumulated,
}: {
  className?: string;
  targetYear: TargetYear | null;
  accountingPeriod: AccountingPeriod | null;
  accumulated: Accumulated | null;
}) => {
  return (
    <div className={cn("flex flex-row items-center gap-[2px]", className)}>
      <span className="label-2-medium text-neutral-500">
        {accountingPeriodToString(accountingPeriod)}
      </span>
      <div className="w-[2px] h-[2px] aspect-square bg-neutral-500 rounded-full" />
      <span className="label-2-medium text-neutral-500">
        {targetYearToString(targetYear)}
      </span>
      <div className="w-[2px] h-[2px] aspect-square bg-neutral-500 rounded-full" />
      <span className="label-2-medium text-neutral-500">
        {accumulationToString(accumulated)}
      </span>
    </div>
  );
};
